<template>
  <Modal :value="showModal" class="new-design-modal" @input="closeModal">
    <div>
      <div class="h-v-centerer new-design-modal__title">
        <h2 class="basic-sub-title">
          {{ $t('message.SHIZEN_NEW_DESIGN') }}
        </h2>
      </div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="h-v-centerer new-design-modal__subtitle" v-html="$t('message.SHIZEN_NEW_DESIGN_VIDEO')" />
      <div class="new-design-modal__video-wrapper">
        <div class="new-design-modal__video-wrapper__video">
          <iframe
            src="https://www.youtube.com/embed/mR2PGvyn_j4"
            title="Shizen new design"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          />
        </div>
      </div>

      <div class="h-v-centerer new-design-modal__buttons">
        <button class="generic-border generic-border--text-btn generic-border--blue" @click="done">
          {{ $t('message.GOT_IT') }}
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
/**
 * The only purpose of this modal is to display the Youtube video of the new design.
 * TODO: Delete translations SHIZEN_NEW_DESIGN and SHIZEN_NEW_DESIGN_VIDEO
 * TODO: Delete LSK_NEW_DESIGN_VIDEO from constants
 * TODO: Remove the iframe from the release notes modal
 */

import toastr from 'toastr';
import Modal from '@/components/modal.vue';
// Utils
import { LSK_NEW_DESIGN_VIDEO_WATCHED } from '@/utils/constants';

export default {

  name: 'NewDesignModal',

  components: {
    Modal,
  },

  data() {
    return {
      showModal: false,
    };
  },

  created() {
    this.checkShowModal();
  },

  methods: {
    /** Check if the modal shoul dbe displayed and show it if so */
    checkShowModal() {
      if (!window.localStorage.getItem(LSK_NEW_DESIGN_VIDEO_WATCHED)) {
        this.openModal();
      }
    },
    /** Display the modal */
    openModal() {
      this.showModal = true;
    },
    /** Closes the rating modal, and reset all of the previous informations in it */
    closeModal() {
      this.showModal = false;
    },
    /** Done button clicked */
    done() {
      window.localStorage.setItem(LSK_NEW_DESIGN_VIDEO_WATCHED, true)
      this.closeModal();
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.new-design-modal {

  &.modal.dark-overlay {
    left: 0px;
    width: 100%;
    z-index: 15000;

    .dark-overlay-content {
      height: auto;
      max-height: 95%;
    }
  }

  &__title {
    margin: 1.5rem 0;

    h2.basic-sub-title {
      margin: 0;
    }

    .icon {
      margin-left: 1.5rem;
      width: 1.4rem;
      height: auto;
    }
  }

  &__subtitle {
    padding: 2rem 6rem;
    text-align: center;
  }

  &__video-wrapper {
    padding: 2rem 5rem;
    width: 100%;
    box-sizing: border-box;

    &--width600 {
      width: 600px;
    }

    &__video {
      width: 100%;
      position: relative;
      height: 0;
      padding-bottom: 56.25%; // 16:9

      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }

  &__buttons {
    margin-bottom: 2rem;
  }
}

@media (max-width: $tablet-landscape) {
  .new-design-modal {
    &__subtitle {
      padding: 1rem 5rem;
    }
  }
}

@media (max-width: $smartphone-landscape) {
  .new-design-modal {
    &.modal.dark-overlay .dark-overlay-content {
      width: 80%;
    }
  }
}

@media (max-width: $smartphone-portrait) {
  .new-design-modal {
    &.modal.dark-overlay .dark-overlay-content {
      width: 95%;
    }

    &__subtitle {
      padding: 1rem 3rem;
    }

    &__video-wrapper {
      padding: 2rem;
    }
  }
}
</style>
